<template>
  <div class="highlights">
    <ul>
      <li
        class="min-w-[6px] h-auto"
        :data-index="index"
        @keydown.enter.stop.prevent="e => addItem(e, index)"
        @keydown.delete.stop="e => removeItem(e, index)"
        @click="evt => openRephrasePopup(`${targetPath}.${index}`, evt.target)"
        v-for="(highlight, index) in highlights"
        :key="highlight"
        v-word-count
        v-editable="isPowerEdit"
        :data-target-path="`${targetPath}.${index}`"
      >
        {{ highlight }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, PropType, toRefs } from 'vue'
import { useStructuredResumeStore } from '@/store/pinia/structuredResume'
import { usePowerEditStore } from '@/store/pinia/powerEdit'

export default defineComponent({
  name: 'Highlights',
  props: {
    highlights: {
      type: Array as PropType<string[]>,
      required: true,
    },
    targetPath: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup(props) {
    const powerEditStore = usePowerEditStore()
    const { closePopup, openRephrasePopup } = powerEditStore
    const store = useStructuredResumeStore()
    const { highlights } = toRefs(props)
    const addItem = async (event, index) => {
      highlights.value.splice(index + 1, 0, 'New highlight...')
      await nextTick()
      const nextItem = event.currentTarget?.parentElement?.querySelector(
        `li[data-index="${index + 1}"]`
      )
      focusHighlight(nextItem)
    }
    const removeItem = async (event, index) => {
      if (event.currentTarget?.innerText.trim().length > 0) {
        return
      }
      event.preventDefault()
      const previousItem = event.currentTarget?.parentElement?.querySelector(
        `li[data-index="${index - 1}"]`
      )
      await nextTick()
      setCursor(previousItem)
      store.deleteArrayItem(props.targetPath, index)
    }

    const setCursor = element => {
      if (!element) return
      element.focus()
      const range = document.createRange()
      const selection = window.getSelection()
      range.setStart(element, element.childNodes.length)
      range.setEnd(element, element.childNodes.length)
      range.collapse(true)
      selection?.removeAllRanges()
      selection?.addRange(range)
    }

    const focusHighlight = element => {
      element.focus()
      const selection = window.getSelection()
      selection?.removeAllRanges()
      const range = document.createRange()
      range.selectNodeContents(element)
      selection?.addRange(range)
    }

    return {
      isPowerEdit: store.isPowerEdit,
      addItem,
      removeItem,
      highlights,
      openRephrasePopup,
      closePopup,
    }
  },
})
</script>

<style scoped lang="postcss">
.highlights {
  ul {
    @apply list-disc ml-4-em list-outside;
  }
}
</style>
